import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";

import { useBookingBarContext } from "../booking_bar_provider";
import { ItemGroups } from "./item_groups";

export const DaysOverlay = () => {
  const {
    bar: { start, end },
    draggingMode,
    draggingStartDate,
    draggingEndDate
  } = useBookingBarContext();
  const { utc, formatISODate } = useDateFormatter();

  const days = useMemo<{ date: string; hidden: boolean }[][]>(() => {
    const barStart = draggingMode ? draggingStartDate : start;
    const barEnd = draggingMode ? draggingEndDate : end;
    const daysCount = utc(formatISODate(utc(barEnd))).diff(utc(formatISODate(utc(barStart))), "days") + 1;
    return Array.from({ length: daysCount }).map((_, index) => [
      { date: formatISODate(utc(barStart).add(index, "days")), hidden: false }
    ]);
  }, [start, end, utc, formatISODate, draggingMode, draggingStartDate, draggingEndDate]);

  return <ItemGroups dateGroups={days} />;
};
